{
  "name": "@streamplace/components",
  "version": "0.11.29",
  "description": "Streamplace React (Native) Components",
  "main": "dist/index.js",
  "types": "src/index.tsx",
  "exports": {
    ".": {
      "@streamplace/dev": "./src/index.tsx",
      "types": "./src/index.tsx",
      "default": "./dist/index.js"
    }
  },
  "keywords": [
    "streamplace"
  ],
  "sideEffects": false,
  "author": "Streamplace",
  "license": "MIT",
  "devDependencies": {
    "@types/react-dom": "^19.2.3",
    "@types/sdp-transform": "^2.15.0",
    "tsup": "^8.5.0"
  },
  "dependencies": {
    "@atproto/api": "^0.19.3",
    "@atproto/crypto": "^0.4.5",
    "@atproto/syntax": "^0.6.1",
    "@emoji-mart/react": "^1.1.1",
    "@fluent/bundle": "^0.19.1",
    "@fluent/langneg": "^0.7.0",
    "@fluent/react": "^0.15.2",
    "@gorhom/bottom-sheet": "^5.2.8",
    "@radix-ui/react-dropdown-menu": "^2.1.16",
    "@rn-primitives/dropdown-menu": "^1.2.0",
    "@rn-primitives/portal": "^1.3.0",
    "@rn-primitives/slider": "^1.2.0",
    "class-variance-authority": "^0.6.1",
    "expo-image": "^55.0.6",
    "expo-keep-awake": "^55.0.4",
    "expo-screen-orientation": "^55.0.8",
    "expo-sqlite": "^55.0.10",
    "expo-video": "^55.0.10",
    "graphemer": "^1.4.0",
    "hls.js": "^1.5.17",
    "i18next": "^25.4.2",
    "i18next-browser-languagedetector": "^8.2.0",
    "i18next-fluent": "^2.0.0",
    "i18next-http-backend": "^3.0.2",
    "i18next-resources-to-backend": "^1.2.1",
    "intl-pluralrules": "^2.0.1",
    "lucide-react-native": "^0.562.0",
    "react-i18next": "^15.7.3",
    "react-native": "^0.83.2",
    "react-native-edge-to-edge": "^1.6.2",
    "react-native-gesture-handler": "^2.30.0",
    "react-native-reanimated": "~4.2.1",
    "react-native-safe-area-context": "^5.7.0",
    "react-native-svg": "^15.15.3",
    "react-native-webrtc": "git+https://github.com/streamplace/react-native-webrtc.git#74fa32266e3a2fee180f5e01bb8753af2a92d9d3",
    "react-use-websocket": "^4.13.0",
    "@streamplace/core": "workspace:*",
    "@streamplace/i18n": "workspace:*",
    "streamplace": "workspace:*",
    "viem": "^2.21.44",
    "zustand": "^5.0.5"
  },
  "peerDependencies": {
    "expo-localization": "*",
    "react": "*"
  },
  "peerDependenciesMeta": {
    "expo-localization": {
      "optional": true
    }
  },
  "scripts": {
    "build": "tsc",
    "start": "tsc --watch --preserveWatchOutput",
    "prepare": "tsc"
  }
}
